export default function SuccessCircleIcon({
  size = 36,
  className = '',
  onClick = (event) => {},
  style = {}
}: {
  size?: number;
  className?: string;
  onClick?: (event) => void;
  style?: React.CSSProperties;
}) {
  return (
    <span className={'flex items-center ' + className} onClick={onClick} style={style}>
      <svg
        xmlns='http://www.w3.org/2000/svg'
        width={size}
        height={Math.round((size * 17) / 16)}
        viewBox='0 0 16 17'
        fill='currentColor'
      >
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M10.4421 3.01585C9.26024 2.48926 7.93984 2.3588 6.6778 2.64394C5.41575 2.92908 4.27969 3.61455 3.43905 4.5981C2.59841 5.58165 2.09822 6.81059 2.01309 8.10164C1.92796 9.39269 2.26244 10.6767 2.96666 11.7621C3.67088 12.8475 4.70709 13.6762 5.92076 14.1246C7.13444 14.573 8.46054 14.617 9.7013 14.2502C10.9421 13.8833 12.031 13.1252 12.8057 12.089C13.5804 11.0527 13.9993 9.79371 14.0001 8.49985V7.8869C14.0001 7.51871 14.2986 7.22024 14.6668 7.22024C15.0349 7.22024 15.3334 7.51871 15.3334 7.8869V8.50024C15.3325 10.0816 14.8204 11.6207 13.8736 12.8873C12.9267 14.1539 11.5958 15.0804 10.0793 15.5288C8.56286 15.9772 6.94207 15.9233 5.45869 15.3753C3.97531 14.8273 2.70883 13.8144 1.84812 12.4878C0.98741 11.1612 0.578595 9.59186 0.682644 8.01391C0.786694 6.43596 1.39803 4.93392 2.42549 3.7318C3.45294 2.52968 4.84146 1.6919 6.38395 1.34339C7.92645 0.994884 9.54028 1.15433 10.9848 1.79795C11.3211 1.9478 11.4722 2.34192 11.3224 2.67824C11.1725 3.01455 10.7784 3.16571 10.4421 3.01585Z'
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M15.1378 2.69503C15.3982 2.95525 15.3984 3.37736 15.1382 3.63784L8.47156 10.3112C8.34656 10.4363 8.17695 10.5066 8.00009 10.5067C7.82322 10.5067 7.65358 10.4365 7.52851 10.3114L5.52851 8.3114C5.26816 8.05106 5.26816 7.62895 5.52851 7.3686C5.78886 7.10825 6.21097 7.10825 6.47132 7.3686L7.99968 8.89696L14.1949 2.6955C14.4552 2.43502 14.8773 2.43481 15.1378 2.69503Z'
        />
      </svg>
    </span>
  );
}
